module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust1_en.4b48aa5a94f61e2c452b64925b972c63.png";